const toIntMixin = {
  methods: {
    toInt(value) {
      return parseInt(value) ? parseInt(value) : null;
    }
  }
};

export default toIntMixin;
